import React from 'react';

const GridIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			viewBox="0 0 21 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M19.0938 0.101562H1.90625C1.54365 0.101563 1.1959 0.245605 0.939503 0.502003C0.683105 0.7584 0.539063 1.10615 0.539062 1.46875V15.5312C0.539062 15.8939 0.683105 16.2416 0.939503 16.498C1.1959 16.7544 1.54365 16.8984 1.90625 16.8984H19.0938C19.4564 16.8984 19.8041 16.7544 20.0605 16.498C20.3169 16.2416 20.4609 15.8939 20.4609 15.5312V1.46875C20.4609 1.10615 20.3169 0.7584 20.0605 0.502003C19.8041 0.245605 19.4564 0.101563 19.0938 0.101562ZM1.90625 1.27344H19.0938C19.1456 1.27344 19.1952 1.29401 19.2319 1.33064C19.2685 1.36727 19.2891 1.41695 19.2891 1.46875V5.57031H1.71094V1.46875C1.71094 1.41695 1.73151 1.36727 1.76814 1.33064C1.80477 1.29401 1.85445 1.27344 1.90625 1.27344ZM1.71094 15.5312V6.74219H7.57031V15.7266H1.90625C1.85445 15.7266 1.80477 15.706 1.76814 15.6694C1.73151 15.6327 1.71094 15.5831 1.71094 15.5312ZM19.0938 15.7266H8.74219V6.74219H19.2891V15.5312C19.2891 15.5831 19.2685 15.6327 19.2319 15.6694C19.1952 15.706 19.1456 15.7266 19.0938 15.7266Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default GridIcon;
